import AppStore from '../stores/AppStore'

export function connectionIssues (error, connected) {
  // Normalize some common issue strings so we can reliably branch on them.
  // Many callers pass `Bad status code: XXX` (or throw Errors that stringify to that),
  // and we don't want those to be treated as "not connected" network failures.
  let normalizedError = error
  if (normalizedError && typeof normalizedError.issue === 'string') {
    if (normalizedError.issue.startsWith('Bad status code')) {
      normalizedError = { ...normalizedError, issue: 'Bad status code', originalIssue: normalizedError.issue }
    }
  }

  const lastIssue = AppStore.data.errors.connectionIssues.lastError.issue

  // keep the Unauthorized / Forbidden popups until the user dismisses them
  if (
    connected &&
    lastIssue !== 'Unauthorized' &&
    lastIssue !== 'Forbidden'
  ) {
    AppStore.data.errors.connectionIssues.count = 0
    AppStore.data.notifications.popUp.visible = false
    AppStore.data.notifications.popUp.logout = false
    return AppStore.emitChange()
  }
  if (connected) {
    return false
  }
  const errorIssue = normalizedError && normalizedError.issue
  const errorString = normalizedError && normalizedError.error
    ? String(normalizedError.error)
    : ''

  // Detect HTTP / backend errors that were wrapped as "Error fetching data".
  // These are *not* connectivity problems and should not trigger the "Not Connected" modal.
  const looksLikeHttpError =
    errorIssue === 'Bad status code' ||
    errorString.includes('Bad status code') ||
    errorString.includes('connection issue:')

  switch (errorIssue) {
    case 'Login failed':
    case 'Login Server Request Failed':
    case 'User already exists':
      AppStore.data.notifications.popUp.visible = true
      break
    case 'Server Error':
    case 'Unauthorized':
      AppStore.data.notifications.popUp.visible = true
      AppStore.data.notifications.popUp.logout = true
      break
    case 'Forbidden':
      // logged in but not allowed to see this content: no logout
      AppStore.data.notifications.popUp.visible = true
      AppStore.data.notifications.popUp.logout = false
      break
    case 'Bad status code':
      // Server responded, so we're connected. Don't show the offline modal.
      AppStore.data.notifications.popUp.visible = false
      break
    case 'Error fetching data':
      if (looksLikeHttpError) {
        // Treat backend/HTTP issues as connected; don't increment offline counter.
        // Keep a Forbidden popup that was just shown for this error.
        if (lastIssue === 'Forbidden') return AppStore.emitChange()
        AppStore.data.notifications.popUp.visible = false
        break
      }
      // fallthrough to default network-error counting behavior
      AppStore.data.errors.connectionIssues.count += 1
      if (AppStore.data.errors.connectionIssues.count > 3) {
        AppStore.data.notifications.popUp.visible = true
      }
      break
    default:
      AppStore.data.errors.connectionIssues.count += 1
      if (AppStore.data.errors.connectionIssues.count > 3) {
        AppStore.data.notifications.popUp.visible = true
      }
      break
  }

  switch (errorIssue) {
    case 'Login failed':
    case 'Login Server Request Failed':
    case 'User already exists':
    case 'Server Error':
    case 'Unauthorized':
    case 'Forbidden':
      AppStore.data.notifications.popUp.text = errorIssue
      break
    case 'Bad status code':
      // Keep the text informative if something else decides to show a popup.
      AppStore.data.notifications.popUp.text = 'Server Error'
      break
    default:
      AppStore.data.notifications.popUp.text = 'Not Connected'
      break
  }

  AppStore.data.errors.connectionIssues.lastError = normalizedError
  return AppStore.emitChange()
}
